export default __webpack_public_path__ + "static/media/money-back@2x.0b6867b7.png";